<div
  class="d-flex flex-wrap s-p-3 mat-elevated-item border rounded-bottom border-top-0 align-items-center"
>
  <ng-content select="[slot=aditional-data]"> </ng-content>
  <div
    class="d-flex flex-wrap align-items-center justify-content-center s-grow-3"
  >
    <button
      mat-icon-button
      type="button"
      [disabled]="page === 1"
      (click)="paginate(1)"
    >
      <mat-icon> first_page </mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      [disabled]="page === 1"
      (click)="paginate(page - 1)"
    >
      <mat-icon> navigate_before </mat-icon>
    </button>
    <div>
      <input
        type="number"
        class="s-me-2 s-w-17"
        [(ngModel)]="inputPage"
        (keydown.enter)="paginate(inputPage)"
        min="1"
        [max]="total()"
      />
      {{ page }} de {{ total() }}
    </div>
    <button
      mat-icon-button
      type="button"
      [disabled]="page === total()"
      (click)="paginate(page + 1)"
    >
      <mat-icon> navigate_next </mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      [disabled]="page === total()"
      (click)="paginate(total())"
    >
      <mat-icon> last_page </mat-icon>
    </button>
  </div>
  <div>
    <select [formControl]="paginationFormGroupRef().controls.pageSize">
      @for (item of paginationSizeList(); track $index) {
      <option>
        {{ item }}
      </option>
      }
    </select>
  </div>
</div>
